import { flatMap, uniqBy } from 'lodash';
import {
  AssignmentTabs,
  OnBehalfActionType,
  RequestPopupType,
} from '../enums/on-behalf-action-types';

export const MANDATE_STATUS = {
  AwaitingProviderAssignment: 67,
  AwaitingContractAgency: 75,
  RSAIAProcess: 53,
  AwaitingServiceConfirmation: 54,
  Receiving: 55,
  AssistanceNotRequested: 56,
  AllMandates: 0,
  outreachDeadLine: 77,
  Assigned: 85,
  pendingScheduling: 44,
  awaitingFirstAttend: 81,
  recieving: 55
};

export const ASSESSMENT_STATUS = {
  RequestForAssistance: 1,
  AwaitingContractAgencyEvaluator: 75,
  PendingAssignment: 2,
  Assigned: 3,
  AllAssessment: 0,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const RequestType = {
  Assessment: 1,
  Mandate: 2,
};

export enum evalDashboardTabs {
  IncomingRequests = 'incomingRequest',
  RequesttoConfirmCapacity = 'confirmCapacity',
  AAProcess = 'aaProcess',
}

export const PA_STATUS_GROUPS_BASE = {
  awaitingProviderAssignment: [
    // { id: 67, description: 'Awaiting Provider Assignment' },
    { id: 51, description: 'Awaiting Location Provider' },
    { id: 60, description: 'Rejected by Provider' },
    { id: 86, description: 'Awaiting Bilingual Provider'},
    // { id: 116, description: 'Awaiting SETSS Auth' },
       // { id: 61, description: 'Terminated Without First Attend' },
    // { id: 63, description: 'Terminated (Never Assigned)' },
  ],

  awaitingContractAgency: [
    { id: 71, description: 'Contract Assistance Requested' },
    { id: 72, description: 'Contract Agency Timeout' },
    { id: 73, description: 'Primary Agency Does not Exist' },
    { id: 89, description: 'Withdrawn from Contract Agency' },
    { id: 88, description: 'Contract Agency Rejected' },
    // { id: 85, description: 'Assigned' },
    // { id: 121, description: 'Pending Caseload Assignment Confirmation' },
  ],

  awaitingServiceConfirmation: [
    { id: 78, description: 'Awaiting Location Provider Confirmation' },
    { id: 44, description: 'Pending Schedule' },
    { id: 81, description: 'Awaiting First Attend' },
    // { id: 66, description: 'Pending Termination' },
    { id: 65, description: 'Pending 5 School Day Notification'},
    { id: 61, description: 'Terminated Without First Attend'},
    { id: 62, description: 'Terminated (Never Served)' },
   //  { id: 129, description: 'Awaiting Independent Provider Confirmation'},
    //  { id: 130, description: 'Awaiting Independent SETSS Teacher Confirmation'},
     { id: 131, description: 'Reason for Delay Needed'},

  ],

  assisstanceNotRequested: [
    { id: 56, description: 'Assistance Not Requested' },
    // { id: 71, description: 'Contract Assistance Requested' },
    // { id: 62, description: 'Terminated (Never Served)' },
  ],

  receiving: [
    { id: 64, description: 'Terminated' },
    { id: 65, description: 'Pending 5 School Day Notification' },
    // { id: 66, description: 'Pending Termination' },
    { id: 119, description: 'Last Encountered' },
    // { id: 63, description: 'Terminated (Never Assigned)' },
    // { id: 62, description: 'Terminated (Never Served)' }
  ],

  outreachbydeadline: [
    { id: 90, description: 'Pending Contract Agency Responses' },
    // {
    //   id: 91,
    //   description: 'Pending Contract Agency and Independent Agency Responses',
    // },
    { id: 101, description: 'Ready To Award' },
    { id: 117, description: 'No Responses Received'},
  ],

  rsaIaP4Process: [
   // {id:126, description: 'Awaiting RSA'},
  //  {id:127, description: 'Awaiting IA'},
    // { id: 68, description: 'RSA Revoked' },
   // { id: 69, description: 'IA Revoked' },
   //  { id: 70, description: 'P-4 Revoked' },
    { id:104, description: 'RSA Issued Awaiting Independent provider'},
    { id: 106, description: 'IA Issued Awaiting Independent provider'},
     { id: 105, description: 'P-4 Issued /Awaiting Independent SETSS teacher'},
    // { id: 62, description: 'Terminated (Never Served)' },
    // { id: 63, description: 'Terminated (Never Assigned)' },
    // { id: 64, description: 'Terminated' },
    // { id: 61, description: 'Terminated Without First Attend' },
    { id: 116, description: 'Awaiting SETSS Auth' },
  ],
};
export const PA_STATUS_GROUPS = {
  ...PA_STATUS_GROUPS_BASE,

 allMandates: uniqBy(
    flatMap(PA_STATUS_GROUPS_BASE),
    'id'
  ),
};
export const MANDATE_STATUS_ID = {
  PENDING_CASELOAD_ASSIGNMENT_CONFIRMATION: 121,
  AWAITING_IA: 127,
  IA_ISSUED_AWAITING_INDEPENDENT_PROVIDER: 106,
  IA_REVOKED: 69,
  PENDING_5_SCHOOL_DAY_NOTIFICATION: 65,
  TERMINATED_WITHOUT_FIRST_ATTEND: 61,
  TERMINATION_NEVER_SERVED: 62,
  REASON_FOR_DELAY_NEEDED: 131,
  AWAITING_LOCATION_PROVIDER_CONFIRMATION: 78,
} as const;
export const ASSESSMENT_STATUS_ID = {
  PENDING_ASSIGNMENT: 1,
  WITHDRAWN: 99,
  DECLINED: 100,
  READY_TO_AWARD: 101,
  PENDING_CONTRACT_AGENCY_RESPONSE: 90,
  AA_ISSUED_AWAITING_INDEPENDENT_PROVIDER: 108,
  NO_RESPONSES_RECEIVED: 117,
} as const;
export const EA_STATUS_GROUPS_BASE = {
  requestForAssistance: [
    { id: 1, description: 'Pending Assignment' },
    { id: 99, description: 'Withdrawn' },
    { id: 100, description: 'Declined' },
    { id: 101, description: 'Ready to Award' },
    { id: 108, description: 'AA Issued/Awaiting Independent Provider' },
    { id: 90, description: 'Pending Contract Agency Responses' },
    { id: 117, description: 'No Responses Received'},
  ],
  awaitingContractAgencyEvaluator: [
    // { id: 90, description: 'Pending Contract Agency Response' },
    { id: 46, description: 'Pending Assignment' },
    { id: 99, description: 'Withdrawn' },

  ],
  pendingAssignment: [{ id: 46, description: 'Pending Assignment' }],
  assigned: [
    { id: 44, description: 'Pending Schedule' },
    { id: 28, description: 'Scheduled' },
    { id: 26, description: 'Rescheduled' },
    { id: 3, description: 'Pending Review' },
    { id: 35, description: 'Pending Approval' },
    { id: 24, description: 'Finalized' },
  ],
  allAssessments: [],
};
export const EA_STATUS_GROUPS = {
  ...EA_STATUS_GROUPS_BASE,
  allAssessments: uniqBy(
    flatMap(EA_STATUS_GROUPS_BASE),
    'id'
  ),
};

export const STATUS_DETAILS_MAP: Record<number, { id: number; description: string }[]> = {
  [MANDATE_STATUS.AwaitingProviderAssignment]:
    PA_STATUS_GROUPS.awaitingProviderAssignment,

  [MANDATE_STATUS.AwaitingContractAgency]:
    PA_STATUS_GROUPS.awaitingContractAgency,

  [MANDATE_STATUS.AwaitingServiceConfirmation]:
    PA_STATUS_GROUPS.awaitingServiceConfirmation,

  [MANDATE_STATUS.AssistanceNotRequested]:
    PA_STATUS_GROUPS.assisstanceNotRequested,

  [MANDATE_STATUS.Receiving]:
    PA_STATUS_GROUPS.receiving,

  [MANDATE_STATUS.outreachDeadLine]:
    PA_STATUS_GROUPS.outreachbydeadline,

  [MANDATE_STATUS.RSAIAProcess]:
    PA_STATUS_GROUPS.rsaIaP4Process,

  [MANDATE_STATUS.AllMandates]:
    PA_STATUS_GROUPS.allMandates,
  
};
export const EA_STATUS_DETAILS_MAP: Record<number, { id: number; description: string }[]> = {
  [ASSESSMENT_STATUS.RequestForAssistance]: 
    EA_STATUS_GROUPS.requestForAssistance,

  [ASSESSMENT_STATUS.AwaitingContractAgencyEvaluator]:    
    EA_STATUS_GROUPS.awaitingContractAgencyEvaluator,

  [ASSESSMENT_STATUS.PendingAssignment]:  
    EA_STATUS_GROUPS.pendingAssignment,

  [ASSESSMENT_STATUS.Assigned]: 
    EA_STATUS_GROUPS.assigned,

  [ASSESSMENT_STATUS.AllAssessment]:
    EA_STATUS_GROUPS.allAssessments,

}

export const ALLOWED_STATUSES_ON_BEHALF: Partial<Record<OnBehalfActionType, number[]>> = {
  [OnBehalfActionType.Accept]: [51, 54, 78],
  [OnBehalfActionType.Reject]: [51, 54, 78, 81, 44],
  [OnBehalfActionType.Confirm]: [],
  [OnBehalfActionType.Terminate]: [81, 55, 44, 78,119],
  [OnBehalfActionType.Reassign]: [],
  [OnBehalfActionType.TempAssign]: [],
  [OnBehalfActionType.ReassignCA]: [],
  [OnBehalfActionType.FirstAttend]: [81, 55],
  [OnBehalfActionType.SubmitOutreachFFS]: [],
  [OnBehalfActionType.AwardSystemRecommFFS]: [101],
  [OnBehalfActionType.AcceptCase]: [78],
  [OnBehalfActionType.RejectCase]: [],
};

export const ALLOWED_STATUSES_REQUEST_POPUP: Partial<Record<RequestPopupType, number[]>> =
  {
    [RequestPopupType.AwardDWS]: [101],
  };


export const MANDATE_SHORT_CODES = [
  { id: 1, description: 'S' },
  { id: 2, description: 'IEP' },
  { id: 3, description: 'SP' },
  { id: 4, description: '3W' },
  { id: 5, description: '30' },
  { id: 6, description: '1' },
  { id: 7, description: 'EN' },
  { id: 8, description: '10M' },
  { id: 9, description: '3' },
];
export const MANDATE_DEFINITIONS = [
  {
    number: 1,
    symbol: 'S',
    definition: 'Type of Student (S for School Age, P for Preschool)',
  },
  {
    number: 2,
    symbol: 'IEP',
    definition: 'Type of Conference Document (IEP, IESP, SP, CSP, Preschool IEP)',
  },
  {
    number: 3,
    symbol: 'SP',
    definition: 'Service Type (e.g., Speech-Language Therapy)',
  },
  {
    number: 4,
    symbol: '3W',
    definition: 'Mandated Frequency (e.g., 3 times per week)',
  },
  {
    number: 5,
    symbol: '30',
    definition: 'Mandated Duration (e.g., 30 minutes)',
  },
  {
    number: 6,
    symbol: '1',
    definition: 'Mandated Group Size (e.g., Individual or 2-8 for Group)',
  },
  {
    number: 7,
    symbol: 'EN',
    definition: 'Mandated Language of Service (e.g., English)',
  },
  {
    number: 8,
    symbol: '10M',
    definition: '10 or 12 Month Service (e.g., 10 month)',
  },
  {
    number: 9,
    symbol: '3',
    definition:
      'The mandate listed order on the IEP (e.g., Speech-Language Therapy is the 3rd mandate)',
  },
];

export enum MandateStatusColor {
  Green = 1,
  Yellow = 2,
  Red = 3,
  White = 4, // No Responses Received
}

export const ASSIGNMENT_TAB_CONFIG: Record<string, {
  statuses: Partial<Record<keyof typeof MANDATE_STATUS, {
    tabs: AssignmentTabs[],
    default: AssignmentTabs
  }>>
}> = {
  LocSup: {
    statuses: {
      AwaitingProviderAssignment: {
        tabs: [AssignmentTabs.Providers, AssignmentTabs.Bundles],
        default: AssignmentTabs.Providers
      },
      AwaitingContractAgency: {
       tabs: [AssignmentTabs.Providers, AssignmentTabs.Bundles],
        default: AssignmentTabs.Providers
      },
      RSAIAProcess: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      AwaitingServiceConfirmation: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      Receiving: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      outreachDeadLine: {
        tabs: [AssignmentTabs.Providers, AssignmentTabs.Bundles],
        default: AssignmentTabs.Providers
      },
      AllMandates: {
        tabs: [
          AssignmentTabs.Providers,
          AssignmentTabs.Bundles
        ],
        default: AssignmentTabs.Providers
      },
    }
  },

  TC: {
    statuses: {
      AwaitingProviderAssignment: {
        tabs: [AssignmentTabs.Providers, AssignmentTabs.Bundles],
        default: AssignmentTabs.Providers
      },
      AwaitingContractAgency: {
        tabs: [AssignmentTabs.Providers, AssignmentTabs.Agencies, AssignmentTabs.Bundles],
        default: AssignmentTabs.Agencies
      },
      RSAIAProcess: {
        tabs: [AssignmentTabs.Providers, AssignmentTabs.Agencies, AssignmentTabs.Bundles],
        default: AssignmentTabs.Agencies
      },
      AwaitingServiceConfirmation: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      Receiving: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      AssistanceNotRequested: {
        tabs: [AssignmentTabs.Agencies, AssignmentTabs.Bundles],
        default: AssignmentTabs.Agencies
      },
      AllMandates: {
        tabs: [AssignmentTabs.Providers, AssignmentTabs.Agencies, AssignmentTabs.Bundles],
        default: AssignmentTabs.Providers
      },
      outreachDeadLine: {
        tabs: [AssignmentTabs.Providers, AssignmentTabs.Agencies, AssignmentTabs.Bundles],
        default: AssignmentTabs.Agencies
      }
    }
  },
  
  AgencySup: {
    statuses: {
      AwaitingContractAgency: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      RSAIAProcess: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      AwaitingServiceConfirmation: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      Receiving: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      AllMandates: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      outreachDeadLine: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
    }
  },

  Provider: {
    statuses: {
      RSAIAProcess: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
      AwaitingServiceConfirmation: {
        tabs: [],
        default: null
      },
      Receiving: {
        tabs: [],
        default: null
      },
      AllMandates: {
       tabs: [],
       default: null
      },
      outreachDeadLine: {
        tabs: [AssignmentTabs.Providers],
        default: AssignmentTabs.Providers
      },
    }
  }
};
export const PENDING_CASELOAD_ASSIGNMENT_CONFIRMATION = {
  id: MANDATE_STATUS_ID.PENDING_CASELOAD_ASSIGNMENT_CONFIRMATION,
  description: 'Pending Caseload Assignment Confirmation',
};
export const mandatesNavigationTo: string[] = ['rsa', 'aa', 'encounters', 'ofs'];